module.exports = __webpack_public_path__ + "img/-e-review_btn_play@2x.abadfb0b.png";